var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { businessOwnerRoutes } from "./owner";
export var businessRoutes = __spreadArray([], businessOwnerRoutes);
